import { FC } from "react";
import classNames from "classnames";

import { DataLoadErrorProps } from "./DataLoadError.types";
import Button from "../Button/Button";

import styles from "./DataLoadError.module.css";

const DataLoadError: FC<DataLoadErrorProps> = ({
  message,
  onRetry,
  className,
}) => (
  <div className={classNames(styles.data_load_error, className)}>
    <p className={styles.data_load_error__message}>{message}</p>
    {onRetry && (
      <Button
        typeStyle="outline"
        size="md"
        label="Retry"
        onClick={onRetry}
      />
    )}
  </div>
);

export default DataLoadError;
